var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useForm } from "react-hook-form";
import { useSearchParams } from "react-router-dom";
import { AuthButton, Form, useAuth } from "peggirkit";
import { confirmPasswordReset } from "serpotrack-connector";
import SetPasswordField from "../../../Input/SetPasswordField";
import SetPasswordRepeatedField from "../../../Input/SetPasswordRepeatedField";
var AuthFormResetPasswordConfirmation = function () {
    var searchParams = useSearchParams()[0];
    var intl = useIntl();
    var _a = useForm(), register = _a.register, getValues = _a.getValues, handleSubmit = _a.handleSubmit, watch = _a.watch, errors = _a.formState.errors;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState(null), formError = _c[0], setFormError = _c[1];
    var authContext = useAuth();
    useEffect(function () {
        if (!loading) {
            return;
        }
        var username = searchParams.get("username");
        var token = searchParams.get("token");
        if (username === null || token === null) {
            setFormError(intl.formatMessage({ id: "couldNotResetPassword" }));
            setLoading(false);
            return;
        }
        var submittedData = getValues();
        confirmPasswordReset(username, token, submittedData.password).then(function () {
            authContext === null || authContext === void 0 ? void 0 : authContext.onSignIn(username, submittedData.password).catch(function () {
                setLoading(false);
                setFormError(intl.formatMessage({ id: "signInAfterResetError" }));
            });
        }).catch(function () {
            setFormError(intl.formatMessage({ id: "couldNotResetPassword" }));
            setLoading(false);
        });
    }, [loading]);
    return (_jsxs(Form, __assign({ onSubmit: handleSubmit(function () { return setLoading(true); }), error: formError }, { children: [_jsx(SetPasswordField, { watch: watch, register: register, disabled: loading, fieldError: errors.password, fieldName: "password", displayName: intl.formatMessage({ id: "password" }) }), _jsx(SetPasswordRepeatedField, { compareValue: watch("password"), register: register, disabled: loading, fieldError: errors.passwordRepeated }), _jsx(AuthButton, { disabled: loading, loading: loading, text: intl.formatMessage({ id: "save" }) })] })));
};
export default AuthFormResetPasswordConfirmation;
